import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import { ownerIdZodSchema } from "../owner-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "../translations/translation";
import { uploadIdZodSchema } from "../upload-id";
import type { Byte } from "./file-size-types";

const storageItemBaseZodSchema = z.object({
    _type: z.literal("STORAGE_ITEM"),
    _createdAt: isoAndUnixZodSchema,
    _createdBy: userIdZodSchema,
    title: requiredTranslatableZodSchema,
    path: z.string(),
    filename: z.string(),
    originalFilename: z.string(),
    fileSize: z.number() as unknown as z.ZodSchema<Byte>,
    description: translatableZodSchema.optional(),
    uploadId: uploadIdZodSchema,
    ownerIds: z.array(ownerIdZodSchema),
    categories: z.array(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    bucketName: z.string().optional(),
});
type _StorageItemBase = z.infer<typeof storageItemBaseZodSchema>;

export { storageItemBaseZodSchema };
export type { _StorageItemBase };
